import React from 'react';

export const DownloadIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M8 11.9028V0.972656" stroke="#01619B" />
      <path
        d="M12.4723 7.42969L8.00005 11.9019L3.52783 7.42969"
        stroke="#01619B"
      />
    </g>
  </svg>
);
